webpackJsonp([241467137864693],{

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _YellowButtonMD = __webpack_require__(40);
	
	var _YellowButtonMD2 = _interopRequireDefault(_YellowButtonMD);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var data = _ref.data;
	
	    var news = data.markdownRemark;
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-12" },
	                    _react2.default.createElement(
	                        "h1",
	                        null,
	                        news.frontmatter.title,
	                        " \u2013 (",
	                        news.frontmatter.desc,
	                        ")"
	                    ),
	                    _react2.default.createElement(
	                        "h5",
	                        null,
	                        _react2.default.createElement("span", { style: { color: 'rgba(218, 165, 32, 0.822)' }, className: "glyphicon glyphicon-calendar" }),
	                        " ",
	                        news.frontmatter.date
	                    ),
	                    _react2.default.createElement(
	                        "h5",
	                        null,
	                        "Posted By: ",
	                        news.frontmatter.author
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: news.html } })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-12" },
	                    _react2.default.createElement(
	                        _YellowButtonMD2.default,
	                        { path: "/news" },
	                        "\xAB Return to News"
	                    )
	                )
	            )
	        )
	    );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-new-post-js-ef4b175e95dc2563098c.js